import css from 'styled-jsx/css';

const styles = css.global`body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
   @media (min-width: 992px) {
    #perguntas .perguntas-contain {
      margin-top: 140px;
    }
   }
  @media (min-width: 1280px) {
    .ctn-home-24 {
        padding-right: 0;
        padding-left: 0;
    }
  }
`;

export default styles;